import { createContext } from 'react';
import configuration from './configuration.js';

const ConfigurationContext = createContext(configuration);
export default ConfigurationContext;
